@let state = terminalService.state();

<ol
  class="flex flex-col text-left min-h-[30vh] max-h-[60vh] bg-surface px-3 sm:px-0 rounded border"
>
  @if (!finalizeRequired()) {
    <div class="flex flex-col items-center justify-center mx-auto min-h-[30vh] w-full">
      <img alt="Bankomat Symbol" class="w-16" src="../../../../assets/Bankomat.jpg" />
      @if (state === 'idle') {
        <li class="py-0.5 text-base text-left">Bankomat wird initialisiert...</li>
      } @else {
        @for (message of terminalService.messages(); track $index) {
          <li
            class="py-0.5 text-base text-center px-2.5"
            [ngClass]="$first ? 'mt-1' : ''"
            [class.text-danger-600]="message.type === 'error'"
            [class.text-success-600]="message.type === 'success'"
          >
            {{ message.message }}
          </li>
        }
      }
    </div>
  } @else {
    @for (message of terminalService.messages(); track $index) {
      <li
        class="py-0.5 text-base text-left px-2.5"
        [ngClass]="$first ? 'mt-1' : ''"
        [class.text-danger-600]="message.type === 'error'"
        [class.text-success-600]="message.type === 'success'"
      >
        {{ message.message }}
      </li>
    } @empty {
      @if (state === 'idle') {
        <soft-loading-spinner />
      } @else {
        <div class="flex items-center justify-center mx-auto min-h-[30vh] w-full">
          <img alt="Bankomat Symbol" class="w-16" src="../../../../assets/Bankomat.jpg" />
          <li class="py-0.5 text-base text-left">Bankomat wird initialisiert...</li>
        </div>
      }
    }
  }
</ol>

@if (state === 'completedFailure' || showManualDismissButton()) {
  <div class="flex w-full mt-2.2 border-t pt-2.5">
    <button type="button" class="soft-button primary w-full h-14" (click)="resolve(false)">
      Schließen
    </button>
  </div>
}
